import { datadogRum } from '@datadog/browser-rum';

const initRum = () => {
  const env = window.location.hostname;
  if (env === 'localhost') return;

  datadogRum.init({
    applicationId: process.env.REACT_APP_DATADOG_RUM_APP_ID as string,
    clientToken: process.env.REACT_APP_DATADOG_RUM_CLIENT_ID as string,
    site: 'datadoghq.com',
    service: 'screener-questions',
    env,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [
      /https:\/\/cerebral\.com/,
      /https:\/\/.*\.cerebral\.com/,
      /https:\/\/.*\.getcerebral\.com/,
      /https:\/\/.*\.cerebral-development\.com/
    ]
  });

  datadogRum.startSessionReplayRecording();
};

export default initRum;
